export default __webpack_public_path__ + "/dist/images/italian-restaurent.cdaaa68d321030104a86fd43e478d031.png";